<template>
  <div v-if="calendarErrorState">
    <div class="columns">
      <div
        class="calendar-vertical-error columns__column columns__column--width-main text-content"
      >
        <p>
          <strong class="calendar-vertical-error__error">
            <a-label
              :path="calendarErrorState.errorLabelPath"
              :replace="{
                '###month###': month.monthName,
              }"
              is-visible
            />
          </strong>

          <a-label
            :path="calendarErrorState.hintLabelPath"
            :replace="{
              '###month###': month.monthName,
            }"
            is-visible
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue';

const props = defineProps({
  teaserList: {
    type: Array,
    required: true,
  },
  month: {
    type: Object,
    required: true,
  },
  teaserListForMonth: {
    type: Array,
    required: true,
  },
  teaserListFiltered: {
    type: Array,
    required: true,
  },
  teaserListFilteredForMonth: {
    type: Array,
    required: true,
  },
});

const {
  teaserList,
  teaserListForMonth,
  teaserListFiltered,
  teaserListFilteredForMonth,
} = toRefs(props);

const CALENDAR_ERROR_STATES = Object.freeze({
  none: false,
  noResultsFilteredThisMonth: {
    errorLabelPath: 'calendarErrorStates.NO_RESULTS_FILTERED_THIS_MONTH.error',
    hintLabelPath: 'calendarErrorStates.NO_RESULTS_FILTERED_THIS_MONTH.hint',
  },
  noResultsFiltered: {
    errorLabelPath: 'calendarErrorStates.NO_RESULTS_FILTERED.error',
    hintLabelPath: 'calendarErrorStates.NO_RESULTS_FILTERED.hint',
  },
  noResultsThisMonth: {
    errorLabelPath: 'calendarErrorStates.NO_RESULTS_THIS_MONTH.error',
    hintLabelPath: 'calendarErrorStates.NO_RESULTS_THIS_MONTH.hint',
  },
  noResults: {
    errorLabelPath: 'calendarErrorStates.NO_RESULTS.error',
    hintLabelPath: 'calendarErrorStates.NO_RESULTS.hint',
  },
});

const calendarErrorState = computed(() => {
  if (!teaserList.value.length) {
    return CALENDAR_ERROR_STATES.noResults;
  }
  if (
    !teaserListFilteredForMonth.value.length &&
    teaserListFiltered.value.length
  ) {
    return CALENDAR_ERROR_STATES.noResultsFilteredThisMonth;
  }
  if (
    !teaserListFilteredForMonth.value.length &&
    !teaserListFiltered.value.length
  ) {
    return CALENDAR_ERROR_STATES.noResultsFiltered;
  }
  if (!teaserListForMonth.value.length && teaserList.value.length) {
    return CALENDAR_ERROR_STATES.noResultsThisMonth;
  }

  return CALENDAR_ERROR_STATES.none;
});
</script>
